import type { TrendStatus } from '@ongrid/shared';

/**
 * Format a number with K/M suffix
 */
export function formatNumber(num: number): string {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

/**
 * Format a position (lower is better, show 1 decimal)
 */
export function formatPosition(pos: number | null): string {
  if (pos === null || pos === undefined) return '—';
  return pos.toFixed(1);
}

/**
 * Get badge class for trend status
 */
export function getTrendBadgeClass(status: TrendStatus | null | undefined): string {
  switch (status) {
    case 'New & Growing':
      return 'badge badge-new-growing';
    case 'Growing':
      return 'badge badge-growing';
    case 'Stable':
      return 'badge badge-stable';
    case 'Stagnant':
      return 'badge badge-stagnant';
    case 'Decaying':
      return 'badge badge-decaying';
    case 'New':
      return 'badge badge-new';
    default:
      return 'badge badge-unknown';
  }
}

/**
 * Get color for trend status (for charts)
 */
export function getTrendColor(status: TrendStatus | null | undefined): string {
  switch (status) {
    case 'New & Growing':
      return '#10b981'; // emerald-500
    case 'Growing':
      return '#22c55e'; // green-500
    case 'Stable':
      return '#3b82f6'; // blue-500
    case 'Stagnant':
      return '#eab308'; // yellow-500
    case 'Decaying':
      return '#ef4444'; // red-500
    case 'New':
      return '#a855f7'; // purple-500
    default:
      return '#6b7280'; // gray-500
  }
}

/**
 * Extract path from URL for display
 */
export function extractPath(url: string): string {
  try {
    const parsed = new URL(url);
    return parsed.pathname || '/';
  } catch {
    return url;
  }
}

/**
 * Truncate text with ellipsis
 */
export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - 3) + '...';
}

/**
 * Calculate CTR percentage
 */
export function calculateCTR(clicks: number, impressions: number): string {
  if (impressions === 0) return '0%';
  return ((clicks / impressions) * 100).toFixed(2) + '%';
}

